<script lang='ts'>
    import {ToggleButtonSmall} from "@/Bootstrap";
    import {SelectSlider} from "@/Common";
    import HelpTooltip from "@/Common/HelpTooltip.svelte";
    import { programDiffcultyBounds, strainRatingText, strainRatingDiamonds } from "@/Common/constants";

    export let difficulty: number
    export let difficultyFromTrainingLoad: boolean
    export let disabled = false
    export let onInput: () => void = () => {}
    // Live difficulty computed from the user's current training load (same value the Today
    // card's difficulty_rating uses). Shown -- slider position and readout -- in place of the
    // stored `difficulty` while training-load mode is on, without overwriting the stored value,
    // so turning the toggle back off restores whatever they'd manually picked before.
    export let calculatedDifficulty: number = undefined

    let displayDifficulty: number;
    $: displayDifficulty = (difficultyFromTrainingLoad && calculatedDifficulty != null)
        ? calculatedDifficulty
        : difficulty;

    function onSliderInput() {
        difficulty = displayDifficulty;
        onInput();
    }
</script>

<div class="flex flex-col gap-y-1 w-full">
    <div class="grid items-center">
        <SelectSlider class="col-span-3" {...programDiffcultyBounds} disabled={disabled || difficultyFromTrainingLoad}
            bind:value={displayDifficulty}
            on:input={onSliderInput}
        />
        <span class="row-start-2 text-sm text-slate-400 self-start justify-self-start ml-1">Moderate</span>
        <span data-enabled={!difficultyFromTrainingLoad} class="justify-self-center text-center data-[enabled=false]:text-slate-300">
            {strainRatingText(displayDifficulty)} - {strainRatingDiamonds(displayDifficulty)} - {Math.round(displayDifficulty)}
        </span>
        <span class="text-sm text-slate-400 self-start justify-self-end mr-1">Hard</span>
    </div>

    <div class="flex items-center gap-1 justify-self-start mt-2">
        <ToggleButtonSmall class="text-sm text-slate-500" label={"Based on Training Load"}
            bind:isChecked={difficultyFromTrainingLoad}
            on:change={onInput}
        />
        <HelpTooltip
            message="This sets the difficulty of workouts recommended to follow your training status. The minimum is 2.5 diamonds if your training status is 2.5 stars or less to a maximum of 4 diamonds if your training status is 4 stars or more."
            iconClass="w-5 h-5 text-gray-500"
        />
    </div>
</div>